module.exports = __webpack_public_path__ + "static/media/penGrey.62415615.svg";